import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useScrollAnimation from "../../hooks/UseScrollAnimation";

const ProductCategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  const getLocalizedCategory = (category) => {
    return i18n.language === 'ar' ? category.name_A : category.name_E;
  };

  const handleCategoryClick = (category) => {
    if (category.name_E === "Cosmetic" || category.name_A === "التجميل") {
      navigate("/cosmetic");
    } else {
      onCategoryChange(getLocalizedCategory(category));
    }
  };

  return (
    <div className="flex items-center gap-[7px] flex-wrap">
      {categories.map(category => (
        <button
          key={category.id}
          className={`capitalize px-[30px] py-[7px] rounded-[4px] text-[14px] font-bold ${
            selectedCategory === category.name_E || selectedCategory === category.name_A
              ? 'bg-[#017E89] text-white'
              : 'bg-white text-[#017E89] shadow-md shadow-[#00000024]'
          }`}
          onClick={() => handleCategoryClick(category)}
        >
          {getLocalizedCategory(category)}
        </button>
      ))}
    </div>
  );
};

const ProductCard = ({ product }) => {
  const { i18n } = useTranslation();
  const getLocalizedText = (key) => {
    return i18n.language === 'ar' ? key.A : key.E;
  };

  return (
    <div className="w-100 w-[32%] rounded-[8px] shadow-md shadow-[#00000024]">
      <div className="w-[100%] h-[260px]">
        <img 
          className="w-full h-full rounded-t-[8px] object-cover" 
          src={product.image} 
          alt={getLocalizedText({ A: product.name_ar, E: product.name_en })} 
        />
      </div>
      <div className="p-[20px] flex flex-col gap-[25px] justify-between">
        <div className="flex flex-col gap-[5px]">
          <div className="text-[20px] text-[#017E89] font-bold">
            {getLocalizedText({ A: product.name_ar, E: product.name_en })}
          </div>
          <p className="text-[13px]">
            {getLocalizedText({ A: product.details_ar, E: product.details_en }).length > 100 
              ? `${getLocalizedText({ A: product.details_ar, E: product.details_en }).substring(0, 100)}...` 
              : getLocalizedText({ A: product.details_ar, E: product.details_en })}
          </p>
        </div>
        <Link to={`/productsDetails/${product.id}`} className="flex items-center gap-2">
          <span className="capitalize font-bold">{getLocalizedText({ A: 'المزيد من التفاصيل', E: 'More Details' })}</span>
          <img 
            className="h-auto w-4" 
            src={require("../../assets/icons/twoLines.svg").default} 
            alt="arrow" 
          />
        </Link>
      </div>
    </div>
  );
};

export default function Product() {
  const { t } = useTranslation();
  useScrollAnimation();
  
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("Show All");

  useEffect(() => {
    // Fetch categories
    fetch('https://laravel-api.alnujoud-jo.com/api/categories')
      .then(response => response.json())
      .then(data => {
        const formattedCategories = data.data.map(cat => ({
          id: cat.id,
          name_A: cat.name_A,
          name_E: cat.name_E
        }));
        
        setCategories([{ id: 'all', name_A: 'عرض الكل', name_E: 'Show All' }, ...formattedCategories]);
      })
      .catch(error => console.error('Error fetching categories:', error));

    // Fetch products
    fetch('https://laravel-api.alnujoud-jo.com/api/products')
      .then(response => response.json())
      .then(data => setProducts(data.data))
      .catch(error => console.error('Error fetching products:', error));
  }, []);

  const filterProducts = () => {
    if (selectedCategory === "Show All") return products;
    const categoryId = categories.find(cat => cat.name_E === selectedCategory || cat.name_A === selectedCategory)?.id;
    return products.filter(product => product.category.id === categoryId);
  };

  return (
    <>
      <section className="landingpages">
        <div className="container h-full flex flex-col items-center justify-center text-center">
          <div className="btmAni1256 text-[#017E89] font-bold text-[35px] capitalize">
            {t("Products")}
          </div>
          <div className="btmAni2000 flex items-center gap-[5px] font-bold">
            <Link to={'/'}>{t("Home")}</Link> - 
            <span className="text-[#017E89] capitalize">{t("Products")}</span>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container flex flex-col gap-[50px]">
          <ProductCategoryFilter
            categories={categories}
            selectedCategory={selectedCategory}
            onCategoryChange={setSelectedCategory}
          />
          <div className="flex gap-[10px] flex-wrap">
            {filterProducts().map(product => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
